import api from './api-backend';
import { MyProfileUpdateRequest, MyPasswordChangeRequest, MyProfileResponse } from 'types/profile';

/**
 * Profile service for user profile related API calls
 */
const profileService = {
  /**
   * Get the current user's profile
   * @returns {Promise<MyProfileResponse>} User profile data
   */
  getMyProfile: async (): Promise<MyProfileResponse> => {
    const response = await api.get('/v1/users/me');
    return response.data;
  },

  /**
   * Update the current user's profile
   * @param {MyProfileUpdateRequest} data - Profile data to update
   * @returns {Promise<MyProfileResponse>} Updated user profile
   */
  updateMyProfile: async (data: MyProfileUpdateRequest): Promise<MyProfileResponse> => {
    const response = await api.put('/v1/users/me', data);
    return response.data;
  },

  /**
   * Change the current user's password
   * @param {MyPasswordChangeRequest} data - Password change data
   * @returns {Promise<{ message: string }>} Response from password change
   */
  changePassword: async (data: MyPasswordChangeRequest): Promise<{ message: string }> => {
    const response = await api.put('/v1/users/me/password', data);
    return response.data;
  },
};

export default profileService;
